<template>
  <div>
    <c-text-field
      v-if="!isWhatsapp"
      :id="seleniumDynamicFiled(seleniumIds.SELENIUM_TEST_REGISTER_NICKNAME, index)"
      :model-value="messenger.nickname"
      type="text"
      class="text-caption"
      autocomplete="wqwwq"
      hide-details
      large-text
      height="48px"
      :placeholder="messengerPlaceholder"
      v-bind="$attrs"
      bg-color="transparent"
      :clearable="false"
      @update:model-value="setNickname($event)"
    />
    <phone-input
      v-else
      :model-value="messenger.nickname"
      @input="setNickname($event)"
      @set-error="$emit('set-error', $event)"
    />
  </div>
</template>

<script>
  import { CTextField } from '@clickadilla/components/components'
  import { seleniumIds } from '@clickadilla/components/constants'
  import { seleniumDynamicField } from '@clickadilla/components/utils'
  import PhoneInput from '@/components/PhoneInput.vue'

  export default {
    name: 'FieldNickname',
    components: {
      PhoneInput,
      CTextField
    },
    props: {
      chosenMessengers: {
        type: Array,
        default: () => []
      },
      messenger: {
        type: Object,
        default: () => ({})
      },
      index: {
        type: Number,
        required: true
      }
    },
    emits: ['select-messengers', 'set-error'],
    data() {
      return {
        seleniumIds
      }
    },
    computed: {
      messengerPlaceholder() {
        return {
          Teams: 'username',
          Telegram: '@username or phone',
          Wechat: 'WeChatid or phone',
          Whatsapp: 'phone',
          Facebook: 'username',
          Line: 'Line id or phone',
          Email: 'hi@gmail.com'
        }[this.messenger.name] ?? 'username or phone'
      },
      isWhatsapp() {
        return this.messenger.name.toLowerCase() === 'Whatsapp'.toLowerCase()
      }
    },
    methods: {
      seleniumDynamicFiled: seleniumDynamicField,
      setNickname(nickname) {
        const copySelectedMessengers = JSON.parse(JSON.stringify(this.chosenMessengers))
        copySelectedMessengers[this.index].nickname = nickname
        this.$emit('select-messengers', copySelectedMessengers)
      }
    }
  }
</script>
